import { render } from "./NeuronDataRow.vue?vue&type=template&id=8246530a&scoped=true"
import script from "./NeuronDataRow.vue?vue&type=script&lang=js"
export * from "./NeuronDataRow.vue?vue&type=script&lang=js"

import "./NeuronDataRow.vue?vue&type=style&index=0&id=8246530a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8246530a"]])

export default __exports__